import React from "react";
import styles from "./style.module.scss";

interface DateTagProps {
  icon: React.ReactNode;
  keyword: string;
  date: string;
  year: string;
  unreadCount?: number;
}

const DateTag = ({ icon, keyword, date, year, unreadCount }: DateTagProps) => {
  return (
    <div className="flex items-center">
      <div className={styles.dateTagContainer}>
        <div className={styles.iconWrapper}>{icon}</div>

        <p className={styles.dateText}>
          {keyword}, {date}, {year}
        </p>

        {unreadCount && unreadCount > 0 && (
          <>
            <span className={styles.dotSeparator}>•</span>
            <div className={styles.unreadWrapper}>
              <span className={styles.unreadText}>
                {unreadCount} unread notifications
              </span>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default DateTag;
